import type { FC } from 'react';
import { PersonVariant, QDotSeparator, QText } from '../index';
import { PersonStatus } from './Person';
import { QBox, QFlex } from '../../QLayouts';
import { useLibraryTranslation } from '../../i18n';

type QPersonActionTypeAndTimestampProps = {
  status: PersonStatus;
  variant?: PersonVariant;
  showPendingStatus?: boolean;
  actionTimestamp?: string;
};

export const QPersonActionTypeAndTimestamp: FC<
  QPersonActionTypeAndTimestampProps
> = ({ status, variant = 'default', showPendingStatus, actionTimestamp }) => {
  const { t } = useLibraryTranslation();

  const actionTextMapping: Record<PersonStatus, string> = {
    default: '',
    pending: t('personStatus.pending'),
    approved: t('personStatus.approved'),
    declined: t('personStatus.declined'),
    reviewed: t('personStatus.reviewed'),
    added: t('personStatus.added'),
    removed: t('personStatus.removed'),
    commented: t('personStatus.commented'),
    edited: t('personStatus.edited'),
    versioned: t('personStatus.versioned'),
    changedStatus: t('personStatus.changedStatus'),
    markedResolved: t('personStatus.markedResolved'),
    generated: t('personStatus.generated'),
  };
  const showStackedVariantWithActionTimestamp =
    variant === 'stacked' && actionTimestamp;

  if (status === 'pending') {
    return showPendingStatus ? (
      <QText fontSize="sm" color="gray.500">
        {actionTextMapping[status]}
      </QText>
    ) : null;
  }

  if (status === 'default') {
    return actionTimestamp ? (
      <QText fontSize="sm" color="gray.500">
        {actionTimestamp}
      </QText>
    ) : null;
  }

  if (showStackedVariantWithActionTimestamp) {
    return (
      <QFlex direction="column">
        <QText fontSize="sm" color="gray.500">
          {actionTextMapping[status]}
        </QText>
        <QText fontSize="sm" color="gray.500">
          {actionTimestamp}
        </QText>
      </QFlex>
    );
  }

  return actionTimestamp ? (
    <QFlex direction="row" alignItems="center">
      <QText fontSize="sm" color="gray.500">
        {actionTextMapping[status]}
      </QText>
      <QBox mx={1}>
        <QDotSeparator />
      </QBox>
      <QText fontSize="sm" color="gray.500">
        {actionTimestamp}
      </QText>
    </QFlex>
  ) : null;
};
